// extracted by mini-css-extract-plugin
export default {"record-panel":"xcEDc7"};